import { canvasToFile, loadImageElement } from 'utils/helpers';
import { normalizeHeading, rotationCoverScale } from 'utils/satellite-heading';

export async function rotateImageFile(file: File, deg: number): Promise<File> {
  const heading = normalizeHeading(deg);
  if (heading === 0) {
    return file;
  }

  const objectUrl = URL.createObjectURL(file);
  try {
    const image = await loadImageElement(objectUrl);
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('Could not create a canvas to rotate the image');
    }

    const cover = rotationCoverScale(heading);
    context.translate(canvas.width / 2, canvas.height / 2);
    context.rotate((heading * Math.PI) / 180);
    context.scale(cover, cover);
    context.drawImage(image, -image.width / 2, -image.height / 2);

    return await canvasToFile(canvas, file.name, file.type || 'image/jpeg');
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
